<template>
	<div class="scrollable only-y">
		<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-clipboard widget-icon accent-text fs-30"></i> {{ $t('menu.log') }}</h2>
			</div>
		</el-col>

		<el-card>
			<template>
				<div v-for="(val, key) in loggingMessage" :key="key">
					{{ val }}
				</div>
			</template>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
import io from 'socket.io-client';
const socket = io('http://localhost:7789');
// const socket = io('http://202.158.139.93:7789', {transports: ['websocket'], upgrade: false});
console.log(socket)

export default {
	name: 'Log',
	data () {
		return {
			loggingMessage: []
		}
	},
	methods: {
		logger(){
			socket.on('connect', function(){
				socket.emit('room', 'admin')
			});

			socket.on('message', function(message){
				this.loggingMessage = message
				console.log('logging message',this.loggingMessage)
			});
		}
	},
	async mounted(){
		await this.logger()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
